import React from 'react';
import { HOME_STATS } from '../../data/homepageLifeSlides';

function HomeStatsStrip() {
  return (
    <section className="home-stats-section">
      <div className="container">
        <h2 className="home-stats-section__title">Otthonunk számokban</h2>
        <div className="home-stats-grid">
          {HOME_STATS.map((stat) => (
            <article key={stat.id} className="home-stat-card">
              <span className="home-stat-card__value">{stat.value}</span>
              <span className="home-stat-card__label">{stat.label}</span>
              <span className="home-stat-card__hint">{stat.hint}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeStatsStrip;
